import { FunctionComponent } from "react";

interface ContainerProps {
    image: string
}

const StepHeader: FunctionComponent<ContainerProps> = (props) => {
    const image = props.image

    return (
        <div className="row justify-content-center">
            <div className="col-xs-8 col-sm-8 col-md-8 col-lg-4 bottommargin">
                <img className="img-fluid" alt="header" src={image} />
            </div>
        </div>
    )
}
export default StepHeader;